import { useAlert as useReactAlert, } from "react-alert";
export const useAlert = () => {
    const alert = useReactAlert();
    const warn = (message, options) => {
        const warning = { warningMessage: message };
        return alert.show(warning, options);
    };
    return {
        ...alert,
        warn,
    };
};
